module.exports = __webpack_public_path__ + "static/media/setting.6540322c.svg";